import {ValueObject} from '@s-ui/domain'

export class CaptchaFormValueObject extends ValueObject {
  /**
   * @param {Object} params
   * @param {String} params.siteKey
   * */
}
